module.exports = __webpack_public_path__ + "img/delete-2-alternate.7e0c09f2.svg";